import { KYC_VERIFICATION_CONFIG } from "@/modules/external-verification/config";
import { ExternalVerificationRedirectPage } from "@/modules/external-verification/pages/redirect-page";
import { ExternalVerificationReturnPage } from "@/modules/external-verification/pages/return-page";
import { type CheckoutSession } from "@/types";

interface KycRedirectPageProps {
  onCheckoutFetched: (session: CheckoutSession) => void;
}

export function KycRedirectPage(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _props: KycRedirectPageProps,
) {
  return <ExternalVerificationRedirectPage config={KYC_VERIFICATION_CONFIG} />;
}

export function KycReturnPage({
  onCheckoutFetched,
}: KycRedirectPageProps) {
  return (
    <ExternalVerificationReturnPage
      config={KYC_VERIFICATION_CONFIG}
      onCheckoutFetched={onCheckoutFetched}
    />
  );
}
